import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import Receipts from './pages/Receipts';
import ReceiptAuthentication from './pages/ReceiptAuthentication';
import SignIn from './pages/SignIn';
import { CssBaseline, createMuiTheme, ThemeProvider } from '@material-ui/core';
import Settings from './pages/Settings';
import './styles.css';

const App = () => {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#9d2449"
      }
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/receipts" component={Receipts} />
          <Route exact path="/receipts/authentication" component={ReceiptAuthentication} />
          <Route exact path="/signin" component={SignIn} />
          <Route exact path="/settings" component={Settings} />
          <Route component={NotFound} />
        </Switch>
      </Router>
      <CssBaseline />
    </ThemeProvider>
  );
}

export default App;
